module.exports = __webpack_public_path__ + "static/media/avc_report.8c6f798e.svg";